import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useEffect, useState } from "react";
import { getCatalogMoldSizes } from "../../../repositories/CatalogMoldSizeRepository";
import { TableMoldSize } from "../components/TableMoldSize";
import { useCatalogMoldSizeContext } from "../context/CatalogMoldSizeContext";
type Props = {};

export const CatalogMoldSizePage = (props: Props) => {
	const { state, actions } = useCatalogMoldSizeContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const getCatalogMoldSizesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogMoldSizes();
		if (resp.ok) {
			actions.setMoldSizes(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};
	useEffect(() => {
		getCatalogMoldSizesFromAPI();
	}, []);
	if (state.moldSizes) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableMoldSize
								isLoading={isLoading}
								getCatalogMoldSizesFromAPI={getCatalogMoldSizesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			item
			xs={12}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
